/**
 * Carregamento dos perfis e revalidação periódica. Só baixa quando a camada é
 * ligada pela primeira vez — quem nunca abre a aba não paga nada.
 */
import { carregarSondagens } from './api';
import { useSoundingStore } from './store';

let emVoo: AbortController | null = null;
let jaCarregou = false;

export async function carregarPerfis(force = false): Promise<void> {
  const { situacao } = useSoundingStore.getState();
  if (!force && (situacao.estado === 'loading' || jaCarregou)) return;

  emVoo?.abort();
  const ctrl = new AbortController();
  emVoo = ctrl;
  useSoundingStore.getState().setSituacao({ estado: 'loading', erro: null });

  try {
    const dados = await carregarSondagens(ctrl.signal);
    if (ctrl.signal.aborted) return;
    jaCarregou = true;
    useSoundingStore.getState().setDados(dados);
    useSoundingStore.getState().setSituacao({ estado: 'ready', erro: null });
  } catch (e) {
    if (ctrl.signal.aborted) return;
    useSoundingStore.getState().setSituacao({
      estado: 'error',
      erro: e instanceof Error ? e.message : String(e),
    });
  } finally {
    if (emVoo === ctrl) emVoo = null;
  }
}

/** Revalidação do ciclo automático — só se a camada estiver em uso. */
export function refreshSondagens(): void {
  if (!jaCarregou || !useSoundingStore.getState().visivel) return;
  void carregarPerfis(true);
}

export function startSoundingSync(): () => void {
  if (useSoundingStore.getState().visivel) void carregarPerfis();
  return useSoundingStore.subscribe((a, b) => {
    if (a.visivel && !b.visivel) void carregarPerfis();
  });
}
